import * as React from 'react';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { StripeBillingDetailsInputForm } from './stripe/StripeBillingDetailsInputForm';
import { BillingDetailsProperties } from './interfaces/BillingDetailsInterfaces';

const BillingDetailsInputForm = (props: BillingDetailsProperties) => {
    const elements = useElements();
    const stripe = useStripe();
    return (
            <StripeBillingDetailsInputForm
                stripe={stripe}
                elements={elements}
                billingAddress={props.billingAddress}
                cardData={props.cardData}
                onReset={props.onReset}
                onCardDataChange={props.onCardDataChange}
                onCommit={props.onCommit}
                isCommitInitiated={props.isCommitInitiated}
                billingName={props.billingName}
                description={props.description}
                onAddressDataChange={props.onAddressDataChange}
                taxInfo={props.taxInfo}
            />
    );
};

export { BillingDetailsInputForm };



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/BillingDetailsInputForm.tsx